import React from 'react'

import { cx } from '../utils'

export enum SizeEnum {
  xs = 'loading-xs',
  sm = 'loading-sm',
  lg = 'loading-lg',
  xl = 'loading-xl',
}

export interface LoaderProps {
  size?: keyof typeof SizeEnum | null
  isLight?: boolean
  fullScreen?: boolean
}

// Note: added fullScreen so if multiple providers need to show a loading indicator
// they all line up. Was seeing a jumping spinner because dashboard was showing they
// loader centered in the content area, but api provider was showing it centered on
// the full page.
export default function Loader({ size = null, isLight = false, fullScreen = false }: LoaderProps) {
  return (
    <div className={`h-full w-full flex justify-center items-center ${fullScreen ? 'absolute top-0 left-0' : ''}`}>
      <span
        className={cx(
          `loading loading-spinner${size ? ` loading-${size}` : ''}`,
          isLight ? 'text-base-100' : 'text-primary'
        )}
      ></span>
    </div>
  )
}
